import { createContext } from 'react';
import { SMALL } from '@core-ui/breakpoint-provider';
import { GridContextType } from './types';

const GridContext = createContext<GridContextType>({
  numberOfColumns: 1,
  size: SMALL,
});
const GridContextProvider = GridContext.Provider;
const GridContextConsumer = GridContext.Consumer;

export { GridContextProvider, GridContextConsumer };
export default GridContext;
